const StarIcon = () => {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      viewBox="0 0 56 53"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.0767 1.21993C27.4183 0.398637 28.5817 0.398636 28.9233 1.21993L35.7005 17.5143C35.8445 17.8605 36.1702 18.0971 36.5439 18.1271L54.1351 19.5374C55.0218 19.6084 55.3813 20.7149 54.7057 21.2936L41.3031 32.7744C41.0183 33.0183 40.894 33.4011 40.981 33.7659L45.0757 50.9318C45.2821 51.7971 44.3408 52.4809 43.5817 52.0173L28.5213 42.8184C28.2012 42.6229 27.7988 42.6229 27.4787 42.8184L12.4183 52.0173C11.6592 52.4809 10.7179 51.7971 10.9243 50.9318L15.019 33.7659C15.106 33.4011 14.9817 33.0183 14.6969 32.7744L1.29426 21.2936C0.618723 20.7149 0.978248 19.6084 1.8649 19.5374L19.4561 18.1271C19.8298 18.0971 20.1555 17.8605 20.2995 17.5143L27.0767 1.21993Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default StarIcon
